module.exports = __webpack_public_path__ + "img/segitiga-hijau-chat.9eb2c818.svg";